// extracted by mini-css-extract-plugin
export default {"sharedIconRoot":"sharedIconRoot---gu4Wb","sharedIcon":"sharedIcon---hSyy0","sharedIconLight":"sharedIconLight---MPi71"};